/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown>, guests: NonNullable<unknown> }} Apartment_From_PriceInputs */

const en_apartment_from_price = /** @type {(inputs: Apartment_From_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`from ${i?.price} / night · up to ${i?.guests} guests`)
};

/**
* | output |
* | --- |
* | "from {price} / night · up to {guests} guests" |
*
* @param {Apartment_From_PriceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const apartment_from_price = /** @type {((inputs: Apartment_From_PriceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apartment_From_PriceInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_apartment_from_price(inputs)
});